var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "radio-group" },
    _vm._l(_vm.options, function(option, i) {
      return _c("ui-radio", {
        key: i,
        attrs: {
          option: option.value,
          label: option.label,
          name: _vm.name,
          error: _vm.errorMode
        },
        model: {
          value: _vm.selected,
          callback: function($$v) {
            _vm.selected = $$v
          },
          expression: "selected"
        }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }